/**
 * CARD TOKENS
 */
import * as p from '../primitives.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createCardTokens(s: SemanticTokens) {
  return {
    base: {
      radius: s.radius.md, // --card-base-radius: var(--radius-8)
      fontFamily: s.typography.fontFamily.base, // --card-base-font-family
    },
    filters: {
      width: '540px',
      gutter: '14px',
      stackedBreakpoint: '40rem',
      mobileMaxHeight: '20rem',
      actionHeight: p.spacing[56],
      background: s.surface.ground,
      borderWidth: '0',
      borderColor: s.border.divider,
      radius: s.radius.lg,
      padding: s.layout.padding.sm,
      shadow: s.shadow.lg,
    },
    title: {
      fontSize: s.typography.fontSize.lg, // --card-title-font-size
      fontWeight: s.typography.fontWeight.semibold, // --card-title-font-weight
      lineHeight: '1.5', // --card-title-line-height
    },
    subtitle: {
      fontSize: s.typography.fontSize.base, // --card-subtitle-font-size
      lineHeight: s.typography.lineHeight.xl, // --card-subtitle-line-height
    },
    contentText: {
      fontSize: s.typography.fontSize.base, // --card-content-font-size
      lineHeight: s.typography.lineHeight.xl, // --card-content-line-height
    },
    headerGap: s.layout.gap.md, // --card-header-gap
    bg: s.surface.ground, // --card-bg: var(--surface-ground)
    fg: s.text.secondary, // --card-fg: var(--text-secondary)
    subtitleFg: s.text.secondary, // --card-subtitle-fg: var(--text-secondary)
  };
}
export const cardTokens = createCardTokens(SEMANTIC);
